import http from '@/utils/http';

export const getDataSummary: () => Promise<any> = () => {
  return http({
    url: '/api/v1/intelligence_pc/datamap/data/summary',
    method: 'post',
    data: {},
  }) as Promise<any>;
};

export const getMonthSummary: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/datamap/month_summary', // 调试新接口，youbin
    // url: '/api/v1/intelligence_pc/datamap/month/summary',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};
export const getMonthSummaries: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/datamap/month_summaries', // 调试新接口，youbin
    // url: '/api/v1/intelligence_pc/datamap/month/summary',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getHistoricalMagnitude: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/datamap/historical_magnitude',
    method: 'post',
    data: payload,
  });
};

export const getMonthlyUpdated: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/datamap/monthly_updated_games',
    method: 'post',
    data: payload,
  });
};

export const getCoverage: (
  type: 'markets' | 'top_game' | 'company',
  payload: any,
) => Promise<any> = (type, payload) => {
  return http({
    url: `/api/v1/intelligence_pc/datamap/${type}/coverage`,
    method: 'post',
    data: payload,
  });
};

export const getSource: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `/api/v1/intelligence_pc/source_metrics/sources`,
    method: 'post',
    data: payload,
  });
};
export const getSourceUpdatedGamesDataSource: () => Promise<any> = () => {
  return http({
    url: '/api/v1/intelligence_pc/datamap/opinions/source',
    method: 'post',
    data: {},
  });
};
export const getSourceUpdatedGamesTotalGames: () => Promise<any> = () => {
  return http({
    url: 'api/v1/intelligence_pc/datamap/data/source',
    method: 'post',
    data: {},
  });
};
export const getMetrics: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `/api/v1/intelligence_pc/source_metrics/metrics`,
    method: 'post',
    data: payload,
  });
};
